<template>
  <div class="animated-data-intelligence" :style="customStyle">
    <!-- <div class="text">{{ text }}</div> -->
    <svg :id="refValue" :ref="refValue">
      <path :id="refValue + 'ellipsePath'" />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    refValue: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '模块化算力',
    },
    duration: {
      type: Number,
      default: 800,
    },
    fastMode: {
      type: Boolean,
      default: false,
    },
    matchedStyle: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      strokeDashoffset: 1000,
      isAnimating: false,
      customStyle: {},
    };
  },
  watch: {
    matchedStyle: {
      immediate: true,
      handler(newVal) {
        let that = this;
        if (newVal) {
          // console.log('watch', newVal);
          let width = newVal.width.toFixed(0);
          let height = newVal.height.toFixed(0);
          let top = newVal.top.toFixed(0);
          let left = newVal.left.toFixed(0);
          let newStyle = {
            width: parseInt(width),
            height: parseInt(height),
          };

          // 应用样式
          this.customStyle = {
            left: left + 'px',
            // top: top + 'px',
            width: width + 'px',
            height: height + 'px',
          };
        }
      },
    },
  },
  mounted() {
    // 窗口大小变化时自动调整
    window.addEventListener('resize', this.updateEllipse());

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // console.log('元素进入可视区域', this.refValue);

          setTimeout(() => {
            this.updateEllipse();
          }, 500);
        } else {
          // console.log('元素离开可视区域', this.refValue);
        }
      });
    });

    observer.observe(this.$refs[this.refValue]);
  },
  methods: {
    updateEllipse() {
      if (!this.matchedStyle) return;
      const svg = document.getElementById(this.refValue);
      const path = document.getElementById(this.refValue + 'ellipsePath');

      // const width = newStyle.width > 95 ? newStyle.width : 95; // 椭圆比文字宽一些
      // const height = newStyle.height > 56 ? newStyle.height : 56; // 椭圆比文字高一些
      const width = this.matchedStyle.width;
      const height = this.matchedStyle.height;
      const cx = width / 2;

      const cy = height / 2;

      // 设置 SVG 尺寸
      svg.setAttribute('width', width);
      svg.setAttribute('height', height);

      // 椭圆路径 (从右上角开始，往左绘制)
      const rx = width / 2;
      const ry = height / 2;
      // console.log(cx, cy, rx, ry);
      let d = null;
      if (this.text.length < 4) {
        d = `
         M ${cx + rx - 30} ${cy - 35}
         A ${rx} ${ry} 0 0 0 ${cx - 30} ${cy - ry}
         A ${rx} ${ry} 0 0 0 ${cx - rx} ${cy}

         A ${rx} ${ry} 0 0 0 ${cx + rx - 15} ${cy + ry - 15}
         A ${rx} ${ry} 0 0 0 ${cx + rx - 10} ${cy - 30}
       `;
      } else {
        d = `
         M ${cx + rx - 30} ${cy - 35}

         A ${rx} ${ry} 0 0 0 ${cx - rx} ${cy}

         A ${rx} ${ry} 0 0 0 ${cx + rx - 15} ${cy + ry - 15}
         A ${rx} ${ry} 0 0 0 ${cx + rx - 10} ${cy - 30}
       `;
      }
      // A ${rx} ${ry} 0 0 0 ${cx} ${cy + ry}
      path.setAttribute('d', d);

      // 动态计算路径长度，更新 dasharray
      const length = path.getTotalLength();
      path.setAttribute('stroke-dasharray', length);
      path.setAttribute('stroke-dashoffset', length);
    },
  },
};
</script>

<style lang="scss" scoped>
.animated-data-intelligence {
  /* display: inline-block;
  margin: 20px; */
  position: absolute;
  z-index: 1;
  top: 0;

  .text {
    //禁止文字换航
    white-space: nowrap;
  }
  svg {
    overflow: visible;
  }
  path {
    fill: none;
    stroke: #4c6ef5; /* 蓝色 */
    stroke-width: 5;
    stroke-linecap: round;
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
    animation: draw 2s forwards;
  }

  @keyframes draw {
    to {
      stroke-dashoffset: 0;
    }
  }
}
</style>
